import { defaultProps } from "helpers/common";
import { Stack, StackProps, Typography, TypographyProps } from "@mui/material";
import { ReactNode } from "react";

export interface AlertTextBoxProps {
    headingText?: string | ReactNode;
    bodyText?: string | ReactNode;
    stackProps?: StackProps;
}

function AlertTextBox(props: AlertTextBoxProps) {
    const stackProps = defaultProps(props?.stackProps || {}, {
        sx: {
            gap: 0.5,
        },
    });

    const headingProps: TypographyProps = {
        sx: {
            fontSize: "16px !important",
            fontWeight: "500 !important",
            lineHeight: 1.5,
            color: "inherit !important",
        },
        children: props.headingText,
    };

    const bodyProps: TypographyProps = {
        sx: {
            fontSize: "12px !important",
            lineHeight: 1.5,
            color: "inherit !important",
        },
        children: props.bodyText,
    };

    return (
        <Stack {...stackProps}>
            {props.headingText && <Typography {...headingProps} />}
            {props.bodyText && <Typography {...bodyProps} />}
        </Stack>
    );
}

export default AlertTextBox;
